import HallOverviewGrid from "./hall-overview-grid";

import "./hall-grids.scss";


const HallGrids = {
    Overview : HallOverviewGrid
}

export default HallGrids;